<template>
  <div class="page-wrapper">
    <HeaderComponent />

    <main class="page-content">
      <AppBreadcrumb :items="[{ label: $t('common.home') }]" />

      <section class="seo-section" :aria-label="$t('home.seoTitle')">
        <h1 class="sr-only">
          {{ $t('home.seoTitle') }}
        </h1>
        <p class="sr-only">
          {{ $t('home.seoDescription') }}
        </p>
      </section>

      <!-- Premium ogohlantirish -->
      <div v-if="!isPremium" class="premium-banner">
        <div class="premium-banner-content">
          <span class="premium-icon">💎</span>
          <div class="premium-text">
            <strong>{{ $t('home.premiumBannerTitle') }}</strong>
            <p>{{ $t('home.premiumBannerText') }}</p>
          </div>
          <a href="https://t.me/smartypx_bot" target="_blank" class="premium-btn">
            {{ $t('home.premiumBannerBtn') }}
          </a>
        </div>
      </div>

      <section class="categories-container" aria-labelledby="categories-title">
        <div class="categories-header">
          <h2 id="categories-title" class="section-title">{{ $t('home.sectionsTitle') }}</h2>
          <p class="section-subtitle">
            {{ $t('home.sectionsSubtitle') }}
          </p>
        </div>

        <nav class="categories-grid" :aria-label="$t('home.sectionsTitle')">
          <div
            v-for="item in categories"
            :key="item.key"
            class="category-item"
          >
            <CategoryCard
              :title="item.title"
              :description="item.description"
              :to="item.to"
              :icon="item.icon"
              :badge="item.badge"
              :badge-color="item.badgeColor"
              :disabled="item.disabled"
              :is-premium-locked="item.isPremiumLocked"
              @premium-click="showPremiumModal = true"
            />
          </div>
        </nav>
      </section>

      <!-- Qulflangan bo'limlar uchun Premium Modal -->
      <a-modal
        v-model:visible="showPremiumModal"
        :title="$t('home.premiumBannerTitle')"
        :footer="null"
        centered
      >
        <div class="premium-modal-content">
          <p>{{ $t('home.premiumBannerText') }}</p>
          <a-button type="primary" href="https://t.me/smartypx_bot" target="_blank" block class="premium-btn-modal">
            {{ $t('home.premiumBannerBtn') }}
          </a-button>
        </div>
      </a-modal>
    </main>
  </div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent.vue'
import AppBreadcrumb from '../components/AppBreadcrumb.vue'
import CategoryCard from '../components/CategoryCard.vue'

export default {
  name: 'HomeView',
  components: {
    HeaderComponent,
    AppBreadcrumb,
    CategoryCard
  },
  data() {
    return {
      showPremiumModal: false
    }
  },
  computed: {
    isPremium() {
      return this.$store.getters['auth/isPremium']
    },
    categories() {
      const premium = this.isPremium
      return [
        {
          key: 'real-exam',
          title: this.$t('home.realExam'),
          description: this.$t('home.realExamDesc'),
          to: '/real-exam',
          icon: '📝'
        },
        {
          key: 'tickets-10',
          title: this.$t('home.tickets10'),
          description: this.$t('home.tickets10Desc'),
          to: '/tickets/10',
          icon: '🔟',
          badge: !premium ? '🔒' : null,
          badgeColor: !premium ? 'red' : null,
          disabled: !premium,
          isPremiumLocked: !premium
        },
        {
          key: 'tickets-20',
          title: this.$t('home.tickets20'),
          description: this.$t('home.tickets20Desc'),
          to: '/tickets/20',
          icon: '📚',
          badge: !premium ? '🔒' : null,
          badgeColor: !premium ? 'red' : null,
          disabled: !premium,
          isPremiumLocked: !premium
        },
        {
          key: 'tickets-50',
          title: this.$t('home.tickets50'),
          description: this.$t('home.tickets50Desc'),
          to: '/tickets/50',
          icon: '🎯',
          badge: !premium ? '🔒' : null,
          badgeColor: !premium ? 'red' : null,
          disabled: !premium,
          isPremiumLocked: !premium
        },
        {
          key: 'wrong-questions',
          title: this.$t('home.wrongQuestions'),
          description: this.$t('home.wrongQuestionsDesc'),
          to: '/wrong-questions',
          icon: '❌',
          badge: !premium ? '🔒' : null,
          badgeColor: !premium ? 'red' : null,
          disabled: !premium,
          isPremiumLocked: !premium
        },
        {
          key: 'fine-points',
          title: this.$t('home.finePoints'),
          description: this.$t('home.finePointsDesc'),
          to: '/fine-points',
          icon: '⚠️'
        },
        {
          key: 'medical-info',
          title: this.$t('home.medicalInfo'),
          description: this.$t('home.medicalInfoDesc'),
          to: '/medical-info',
          icon: '🏥',
          badge: this.$t('home.badgeInProgress'),
          badgeColor: 'orange',
          disabled: true
        },
        {
          key: 'road-signs',
          title: this.$t('home.roadSigns'),
          description: this.$t('home.roadSignsDesc'),
          to: '/road-signs',
          icon: '🚸',
          badge: this.$t('home.badgeInProgress'),
          badgeColor: 'orange',
          disabled: true
        },
        {
          key: 'fines',
          title: this.$t('home.fines'),
          description: this.$t('home.finesDesc'),
          to: '/fines',
          icon: '💸',
          badge: this.$t('home.badgeInProgress'),
          badgeColor: 'orange',
          disabled: true
        }
      ]
    }
  },
  mounted() {
    // Premium statusni yangilash
    this.$store.dispatch('auth/fetchPremiumStatus')
  }
}
</script>

<style scoped>
.premium-modal-content {
  text-align: center;
  padding: 20px 0;
}
.premium-modal-content p {
  margin-bottom: 24px;
  font-size: 15px;
  color: var(--text-secondary);
}
.premium-btn-modal {
  height: 44px;
  background: linear-gradient(135deg, #ff6b35, #f7c948);
  border: none;
  font-weight: 600;
  font-size: 15px;
}
.premium-btn-modal:hover {
  background: linear-gradient(135deg, #f7c948, #ff6b35) !important;
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4) !important;
}

.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg);
}

.page-content {
  flex: 1;
  padding: 0 24px 32px;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

.seo-section {
  margin: 0;
  padding: 0;
}

/* Premium banner */
.premium-banner {
  margin: 16px 0;
  background: linear-gradient(135deg, #ff6b35, #f7c948);
  border-radius: 16px;
  padding: 3px;
}

.premium-banner-content {
  display: flex;
  align-items: center;
  gap: 16px;
  background: var(--bg, #fff);
  border-radius: 14px;
  padding: 16px 20px;
}

.premium-icon {
  font-size: 32px;
  flex-shrink: 0;
}

.premium-text {
  flex: 1;
}

.premium-text strong {
  display: block;
  font-size: 15px;
  color: var(--text, #111);
  margin-bottom: 2px;
}

.premium-text p {
  margin: 0;
  font-size: 13px;
  color: var(--text-secondary, #666);
}

.premium-btn {
  flex-shrink: 0;
  background: linear-gradient(135deg, #ff6b35, #f7c948);
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 13px;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.premium-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
}

.categories-container {
  margin-top: 24px;
}

.categories-header {
  margin-bottom: 18px;
}

.section-title {
  margin: 0 0 6px;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
  color: var(--text, #111827);
}

.section-subtitle {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-secondary, #6b7280);
}

.categories-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}

.category-item {
  width: 100%;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Tablet */
@media (max-width: 1024px) {
  .page-content {
    padding: 0 20px 28px;
  }

  .categories-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  .section-title {
    font-size: 22px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .page-content {
    padding: 0 16px 24px;
  }

  .categories-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
  }

  .section-title {
    font-size: 20px;
  }

  .section-subtitle {
    font-size: 13px;
  }

  .premium-banner-content {
    flex-direction: column;
    text-align: center;
  }
}

/* Small Mobile */
@media (max-width: 576px) {
  .page-content {
    padding: 0 12px 20px;
  }

  .categories-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .section-title {
    font-size: 18px;
  }
}
</style>